import ViewDetails from "../../utils/utilities/ViewDetails";

import { Tab } from "@mui/material";

import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import ContentCutRoundedIcon from '@mui/icons-material/ContentCutRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import WorkHistoryRoundedIcon from '@mui/icons-material/WorkHistoryRounded';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import MonetizationOnRoundedIcon from '@mui/icons-material/MonetizationOnRounded';
import AccountBalanceRoundedIcon from '@mui/icons-material/AccountBalanceRounded';

// Tabs
import DetailsTab from "./Tabs/Details";
import InvoiceTab from "./Tabs/Invoice";


  const tabContent = [
    {panel: "details", content: <DetailsTab />},
    {panel: "invoice", content: <InvoiceTab />},
  ]

const ViewWigOrder = () => {

  const tabs = [
    {label: "General", icon: <ReceiptLongRoundedIcon fontSize="small" />},
    {label: "Invoice", icon: <AccountBalanceRoundedIcon fontSize="small" />, showTab: (data) => data?.invoice_id},
  ];

  return (
    <ViewDetails title="Wig Order" identifier="wig_order_num" tabs={tabs} tabContent={tabContent} isProfile={false} url="wig_orders">

    </ViewDetails>
  )
};

export default ViewWigOrder;